let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("IN5iq")).then(() => parcelRequire('2LOlb'));